import {Box3,Vector3} from 'three';
const box=new Box3(),point=new Vector3(),right=new Vector3(),up=new Vector3();
const pivot=new Vector3(),worldPivot=new Vector3(),corners=new Float64Array(24);
let slopeX=0,slopeY=0,lowX=0,highX=0,lowY=0,highY=0;

// Read bounds once. Uniform scale moves each camera-space corner around the
// object's pivot; testing a candidate needs no scene traversal or mutation.
function prepare(object,camera,edge){
  camera.updateMatrixWorld();object.updateWorldMatrix(true,true);box.setFromObject(object);
  object.getWorldPosition(worldPivot);pivot.copy(worldPivot).applyMatrix4(camera.matrixWorldInverse);
  slopeY=Math.tan(camera.fov*Math.PI/360)*edge;slopeX=slopeY*camera.aspect;
  let k=0;
  for(const x of [box.min.x,box.max.x])for(const y of [box.min.y,box.max.y])for(const z of [box.min.z,box.max.z]){
    point.set(x,y,z).applyMatrix4(camera.matrixWorldInverse);
    corners[k++]=point.x;corners[k++]=point.y;corners[k++]=point.z;
  }
}
function limits(scale){
  lowX=-Infinity;highX=Infinity;lowY=-Infinity;highY=Infinity;
  for(let k=0;k<24;k+=3){
    const x=pivot.x+(corners[k]-pivot.x)*scale,y=pivot.y+(corners[k+1]-pivot.y)*scale,z=pivot.z+(corners[k+2]-pivot.z)*scale;
    const width=-z*slopeX,height=-z*slopeY;
    lowX=Math.max(lowX,-width-x);highX=Math.min(highX,width-x);
    lowY=Math.max(lowY,-height-y);highY=Math.min(highY,height-y);
  }
  return lowX<=highX&&lowY<=highY;
}
function fittingScale(){
  if(limits(1))return 1;
  let lo=0,hi=1;
  // Use the same corner inequalities on either side of the boundary. A
  // nearest-depth/whole-width approximation causes a visible size step here.
  for(let i=0;i<24;i++){const mid=(lo+hi)*.5;if(limits(mid))lo=mid;else hi=mid;}
  return lo;
}
function place(object,camera,scale){
  limits(scale);
  const dx=Math.max(lowX,Math.min(highX,0)),dy=Math.max(lowY,Math.min(highY,0));
  if(dx!==0||dy!==0){
    right.setFromMatrixColumn(camera.matrixWorld,0);up.setFromMatrixColumn(camera.matrixWorld,1);
    point.copy(worldPivot).addScaledVector(right,dx).addScaledVector(up,dy);
    if(object.parent)object.parent.worldToLocal(point);
    object.position.copy(point);
  }
  object.updateMatrixWorld(true);
}

export function fitPlayObject(object,camera,previousScale,held,dt){
  object.scale.setScalar(1);
  prepare(object,camera,.94);
  const required=fittingScale(),previous=previousScale??1;
  // A squeezed shape must not be magnified to refill the screen. Shrink only
  // while held; restore display size gently after the finger is released.
  let scale=Math.min(required,previous);
  if(!held&&required>previous){
    scale=previous+(required-previous)*(1-Math.exp(-Math.min(dt,.1)/.18));
    if(required-scale<.0001)scale=required;
  }
  object.scale.setScalar(scale);place(object,camera,scale);
  return scale;
}

// Bound the complete deformed object, not only the pointer. Camera-space
// inequalities leave a small margin even on a narrow portrait viewport.
export function containPlayObject(object,camera,edge=.94){
  prepare(object,camera,edge);const scale=fittingScale();
  object.scale.multiplyScalar(scale);place(object,camera,scale);
}
